const emailing = {
  en: {
    assignTemplate: "Assign template",
    createTemplate: "Create template",
    insert: "insert",
    emailingSettings: "Email Settings",
    emailingSettingsTitle: "Email Sending Settings",

    emailing: {
      title: "MY TEMPLATES",
      titleForm: "SEND SETTINGS",
      titleContent: "TEMPLATE TEXT",
      attachments: "Attachments",
      attachment: "Attachment",

      labelName: "Template Name",
      labelType: "Trigger event for sending",
      labelIncludeQrCode: "Add a QR code to the confirmation email",
      labelHours: "Setting the sending time",
      desc: "Number of hours to send before booking (for reminder) or after booking (for review request)",
      descReminder:
        "Set the time for your reminder in hours before the reserved slot.",
      descReview:
        "Set the time for your review request in hours after the reserved activity.",
      descLoyalty:
        "Set the frequency in days at which you want to contact your customer base to encourage them to return to your establishment (e.g., 90 days = 3 months).",
      withPromo: "Include a promo code",
      labelPromo: "Amount offered by the promo code (in €)",

      placeholderTextarea: "Please fill in the text below",
      inputFile: "Attachment",
      errorFileSize: "File size exceeds 5MB",
      templateConfirmation: "Booking Confirmation",
      templateCancellation: "Booking Cancellation",
      templateLoyalty: "Loyalty - Customer Base",
      templateReminder: "Reminder prior to the activity",
      templateReview: "Review request after the activity",

      preview: "PREVIEW",
      buttonPrimary: "SAVE TEMPLATE",

      createError: "An error occurred while creating the template",
      updateError: "An error occurred while updating the template",
    },

    assignEmail: {
      title: "CHOICE OF TEMPLATES BY ACTIVITY",
      checkboxEmail: "Send by email",
      checkboxSMS: "Send by SMS",

      activity: "Activity",
      confirmation: "Confirmation",
      cancellation: "Cancellation",
      reminder: "Prior reminder",
      review: "Review request",
      loyalty: "Loyalty",
      remove: "Remove",

      noTemplatesToAssign: "No templates to assign",
      assignTemplate: "Assign a template",

      desc: "If no template is associated with the activity for the event in question, no message will be sent when the event occurs.",
      saveTemplate: "SAVE TEMPLATES FOR EACH ACTIVITY",

      saveSuccess: "Templates assigned successfully",
      saveError: "An error occurred while assigning templates",
    },

    modalDelete: {
      title: "DELETE THIS TEMPLATE ({{name}})?",
      desc: "You are about to delete this template.",
      desc2:
        "If this template is used for any of your activities, they will be reassigned to the default template of the corresponding event.",
      confirm: "Confirm deletion",
      cancel: "Back",
    },

    preview: {
      title: "AUTOMATIC EMAIL PREVIEW",

      hereIsTheContent:
        "Here is the content of the message that your clients will receive for the selected event:",
      emailSmsRappel: "Reminder Email/SMS.",

      theSubject:
        "The subject, greeting and closing phrases, as well as reservation details (schedule, contact information, selected activity, chosen rates...) are automatically generated by HoPleisure.",
      youCanInsert:
        "You can insert a personalized message in the email body, but be careful not to include specific reservation details as this template will be reused for all messages!",
      thisPersonalized:
        "This personalized message appears in green in the preview.",

      confirmReservation: "Booking Confirmation",
      cancelReservation: "Booking Cancellation",
      loyalty: "To thank you for your loyalty - insert.activities.title",
      rappelReservation: "BOOKING REMINDER: insert.activities.title",
      demandeReservation:
        "insert.activities.title - Support us with a positive review !",
      hallo: "Hello ",
      weAreDelighted:
        "We are delighted to have welcomed you recently and we hope you had a great time with us.",
      thankYouLoyalty:
        "To thank you for your loyalty, here's a discount code valid on our activities: ",
      yourBenefit: "It will allow you to benefit from ",
      yourBenefitNext: "euros offered on your next visit!",
      establishmentContact: "Establishment contact details :",
      establishmentEmail: "Email:",
      establishmentTelephone: "Phone:",

      yourContact: "Your contact details:",
      yourEmail: "Email:",
      yourTelephone: "Phone:",

      haveANiceDay: "Have a nice day and see you soon.",

      bookingDetail: "Here are the booking details :",

      activity: "Activities :",

      date: "Date and Time:",

      address: "Address:",

      number: "Number of seats :",

      total: "Total Price :",

      thankYouBookings: "Thank you for booking with ",
      reservationExperience: "Your booking for the experience ",
      canceledBookings: "on the date ",
      canceledBookingsNext: "has unfortunately been canceled.",

      reservationNumber: "Booking Number:",

      receptionPhone: "Reception Phone (Day of Event):",

      desc: "This experience is offered for booking by HoPleisure SAS, registered under the SIREN number 952 553 139, acting on behalf of and for the account of the company ${client_company_name}, registered under the SIREN number ${client_siren}, in accordance with the mandate entrusted to it.",
      qrTitle: "Do not lose this QR code, it will be requested by the manager.",
      attachment: "Attachment:",

      buttonSecondary: "BACK TO EDITION",
      buttonPrimary: "SAVE THE TEMPLATE",
    },

    visitorEmailPolicy: {
      description:
        "Send booking confirmation or cancellation emails to visitors",
      emailTemplateWarning:
        "Warning: Email templates will not be used unless they are linked to an activity.",
      saveSettings: "save settings",
      loading: "Loading options...",

      none: "No email sending",
      internal_only: "Only on HoPleisure channels",
      internal_only_description: "website, widgets, CSE...",
      internal_and_external: "On all channels",
      internal_and_external_description:
        "including platforms with their own email system",

      fetchError: "Failed to load settings.",
      saveError: "Failed to save settings.",
      saveSuccess: "Settings saved successfully.",
    },

    success: {
      templateDeleted: "Template deleted successfully.",
      templateUpdated: "Template updated successfully.",
      templateCreated: "Template created successfully.",
    },

    errors: {
      required: "This field is required.",
      string_min_5: "The value must be at least 5 characters long.",
      invalid_language: "Invalid language code.",
      max_attachments: "You can only upload up to 3 attachments.",
      invalid_file_size: "The file size must not exceed 5MB.",
      invalid_file_type: "Unsupported file type.",
      invalid_url: "Invalid URL format.",
      template_name_required: "Template name is required.",
      trigger_event_required: "Trigger event must be selected.",
      subject_required: "Email subject is required.",
      content_required: "Email content is required.",

      fetchError: "Error loading data.",
    },

    file_type_invalid: "File type must be one of the following: {{types}}",
    file_size_max_limit: "File size must not exceed {{max}} MB",
    EMAIL_TEMPLATE_UPDATED: "Email template updated",
    EMAIL_TEMPLATE_CREATED: "Email template created",
    EMAIL_TEMPLATE_DELETED: "Email template deleted",
    NOT_FOUND: "Resource not found.",

    ACTIVITY_EMAIL_TEMPLATE_UPDATED: "Activity email template updated",
  },
  // French translations
  fr: {
    assignTemplate: "Affecter des templates",
    createTemplate: "Créer des templates",
    insert: "insérer",
    emailingSettings: "Paramètres d'envoi",
    emailingSettingsTitle: "Paramètres d’envoi des emails",

    emailing: {
      title: "MES TEMPLATES",
      titleForm: "PARAMÈTRES DE L'ENVOI",
      titleContent: "TEXTE DU TEMPLATE",
      attachments: "Pièces jointes",
      attachment: "Pièce jointe",

      labelName: "Nom du template",
      labelType: "Évènement déclencheur de l’envoi",
      labelIncludeQrCode: "Ajouter un QR code sur l’email de confirmation ",
      labelHours: "Paramétrage de l’heure d’envoi",
      desc: "Nombre d’heures pour l’envoi avant la réservation (pour le rappel) ou après la réservation (pour la demande d’avis)",
      descReminder:
        "Programmez l’heure de votre rappel, en nombre d’heures avant le créneau réservé.",
      descReview:
        "Programmez l’heure de votre demande d’avis, en nombre d’heures après l’actiivté reservée.",
      descLoyalty:
        "Programmez la fréquence en jours à laquelle vous souhaitez recontacter votre base client pour leur proposer de revenir dans votre établissement (90 jours = 3 mois par exemple).",
      withPromo: "Inclure un code promo",
      labelPromo: "Montant offert par le code promo (en €)",

      placeholderTextarea: "Veuillez remplir le texte ci-dessous",
      inputFile: "Pièce-jointe",
      errorFileSize: "Le fichier dépasse 5Mo",
      templateConfirmation: "Confirmation de réservation",
      templateCancellation: "Annulation de réservation",
      templateLoyalty: "Fidélité - Base client",
      templateReminder: "Rappel préalable à l’expérience",
      templateReview: "⁠Demande d’avis postérieure à l’expérience",

      preview: "APERÇU",
      buttonPrimary: "ENREGISTRER LE TEMPLATE",

      createError: "Une erreur s'est produite lors de la création du template",
      updateError:
        "Une erreur s'est produite lors de la mise à jour du template",
    },

    assignEmail: {
      title: "CHOIX DES TEMPLATES PAR ACTIVITÉ",
      checkboxEmail: "Envoi par email",
      checkboxSMS: "Envoi par SMS",

      activity: "Activité",
      confirmation: "Confirmation",
      cancellation: "Annulation",
      reminder: "Rappel préalable",
      review: "Demande d’avis",
      loyalty: "Fidélité",
      remove: "Retirer",

      desc: "Si aucun template n'est associé à l'activité pour l'événement concerné, aucun message ne sera envoyé lors de la survenance de l'événement.",
      saveTemplate: "SAUVEGARDER LES TEMPLATES POUR CHAQUE ACTIVITÉ",

      noTemplatesToAssign: "Aucun template à affecter",
      assignTemplate: "Affecter un template",

      saveSuccess: "Les templates ont été assignés avec succès",
      saveError: "Une erreur s'est produite lors de l'assignation des modèles",
    },

    modalDelete: {
      title: "SUPPRIMER CE TEMPLATE({{name}}) ?",
      desc: "Vous êtes sur le point de supprimer ce template.",
      desc2:
        "Si ce template est utilisé pour certaines de vos activités, elles seront à nouveau affectées au template par défaut de l’évènement concerné.",
      confirm: "Confirmer la suppression",
      cancel: "Retour",
    },

    preview: {
      title: "PREVISUALISATION DE L’EMAIL AUTOMATIQUE",

      hereIsTheContent:
        "Voici le contenu du message que recevrons vos clients pour l’évènement sélectionné :",
      emailSmsRappel: "Email/SMS de rappel.",

      theSubject:
        "L’objet, les formules de politesse initiales et de clotûre ainsi que les détails de la réservation (horaires, coordonnées, activité choisi, tarifs choisis...) sont automatiquement générés par HoPleisure.",
      youCanInsert:
        "Vous pouvez insérer un passage personnalisé grâce au corps de l’email mais veillez à ne pas inclure d’informations spécifiques à une réservation car ce template sera réutilisé lors de tous les envois !",
      thisPersonalized:
        "Ce message personnalisé apparait en vert dans la prévisualisation.",

      confirmReservation: "Confirmation de réservation",
      cancelReservation: "Réservation annulée",
      loyalty:
        "Pour vous remercier de votre fidélité - insert.activities.title",
      rappelReservation: "Rappel de réservation : insert.activities.title",
      demandeReservation:
        "insert.activities.title - Soutenez-nous avec un avis !",
      hallo: "Bonjour ",
      weAreDelighted:
        "Nous sommes ravis de vous avoir accueilli  récemment et nous espérons que vous avez passé un moment exceptionnel en notre compagnie.",
      thankYouLoyalty:
        "Pour vous remercier de votre fidélité, voici, un code de réduction valable sur nos activité :",
      yourBenefit: "Il vous permettra de bénéficier de ",
      yourBenefitNext: "euros offerts lors de votre prochaine visite !",

      establishmentContact: "Coordonnées de l'établissement :",
      establishmentEmail: "Email :",
      establishmentTelephone: "Téléphone :",

      yourContact: "Vos coordonnées :",
      yourEmail: "Email :",
      yourTelephone: "Téléphone :",

      haveANiceDay: "Bonne journée et à très vite.",

      bookingDetail: "Voici les détails de la réservation :",

      activity: "Activités :",

      date: "Date et heure :",

      address: "Adresse :",

      number: "Nombre de places :",

      total: "Prix total :",

      thankYouBookings: "Merci d'avoir réservé chez ",
      reservationExperience: "Votre réservation pour l’expérience ",
      canceledBookings: "sur la date du ",
      canceledBookingsNext: "a malheureusement due être annulée.",

      reservationNumber: "Numéro de réservation :",

      receptionPhone: "Téléphone de l’accueil (Jour J) :",

      desc: "Cette expérience vous est proposée à la réservation par HoPlaisure SAS, enregistrée sous le numéro SIREN 952 553 139, agissant au nom et pour le compte de la société ${client_company_name}, enregistrée sous le numéro SIREN ${client_siren} conformément au mandat qui lui a été confié.",
      qrTitle: "Ne perdez pas ce QR code, il vous sera demandé par le gérant.",
      attachment: "Pièce-jointe :",

      buttonSecondary: "RETOUR A L’EDITION",
      buttonPrimary: "ENREGISTRER LE TEMPLATE",
    },

    visitorEmailPolicy: {
      description:
        "Envoi d’emails de confirmation de réservation ou d’annulation aux visiteurs",
      emailTemplateWarning:
        "Attention, les modèles d’e-mails créés ne seront pas utilisés tant qu’ils ne sont pas associés à une activité.",
      saveSettings: "sauvegarder les paramètres",
      loading: "Chargement des options...",

      none: "Aucun envoi d’emails",
      internal_only: "Uniquement sur les canaux HoPleisure",
      internal_only_description: "site internet, widgets, CSE...",
      internal_and_external: "Sur tous les canaux",
      internal_and_external_description:
        "y compris les plateformes avec leur propre système d’email",

      fetchError: "Erreur lors du chargement des paramètres.",
      saveError: "Erreur lors de la sauvegarde des paramètres.",
      saveSuccess: "Paramètres sauvegardés avec succès.",
    },

    success: {
      templateDeleted: "Template supprimé avec succès.",
      templateUpdated: "Template mis à jour avec succès.",
      templateCreated: "Template créé avec succès.",
    },

    errors: {
      required: "Ce champ est requis.",
      string_min_5: "La valeur doit contenir au moins 5 caractères.",
      invalid_language: "Code de langue invalide.",
      max_attachments:
        "Vous ne pouvez télécharger que jusqu'à 3 pièces jointes.",
      invalid_file_size: "La taille du fichier ne doit pas dépasser 5 Mo.",
      invalid_file_type: "Type de fichier non pris en charge.",
      invalid_url: "Format d'URL invalide.",
      template_name_required: "Le nom du template est requis.",
      trigger_event_required: "L'événement déclencheur doit être sélectionné.",
      subject_required: "Le sujet de l'email est requis.",
      content_required: "Le contenu de l'email est requis.",

      fetchError: "Erreur lors du chargement des données.",
    },

    file_type_invalid:
      "Le type de fichier doit être l'un des suivants : {{types}}",
    file_size_max_limit: "La taille du fichier ne doit pas dépasser {{max}} Mo",
    EMAIL_TEMPLATE_UPDATED: "Modèle d'e-mail mis à jour",
    EMAIL_TEMPLATE_CREATED: "Modèle d'e-mail créé",
    EMAIL_TEMPLATE_DELETED: "Modèle d'e-mail supprimé",
    NOT_FOUND: "Ressource introuvable.",

    ACTIVITY_EMAIL_TEMPLATE_UPDATED: "Modèle d'e-mail d'activité mis à jour",
  },
};

export default emailing;
